import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleAdd2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleAdd2"><Path d="M15 6.5C15 8.70914 13.2091 10.5 11 10.5C8.79086 10.5 7 8.70914 7 6.5C7 4.29086 8.79086 2.5 11 2.5C13.2091 2.5 15 4.29086 15 6.5Z" stroke="currentColor" strokeLinejoin="round"/><Path d="M11 12.5C6.58172 12.5 3 16.0817 3 20.5H19C19 16.0817 15.4183 12.5 11 12.5Z" stroke="currentColor"/><Path d="M19.5 7V10.5M19.5 10.5V14M19.5 10.5H16M19.5 10.5H23" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPeopleAdd2;
